export type DashboardUnknownRecord = Record<string, unknown>;

export function dashboardValidationFail(path: string, message: string): never {
  throw new Error(`FmDashboardOverview: ${path} ${message}`);
}

export function dashboardRecord(value: unknown, path: string): DashboardUnknownRecord {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    dashboardValidationFail(path, 'must be an object');
  }
  return value as DashboardUnknownRecord;
}

export function dashboardExact(
  value: DashboardUnknownRecord,
  allowed: readonly string[],
  path: string,
): void {
  const unexpected = Object.keys(value).find((key) => !allowed.includes(key));
  if (unexpected) dashboardValidationFail(path, `contains unknown key "${unexpected}"`);
}

export function dashboardString(value: unknown, path: string): string {
  if (typeof value !== 'string' || value.trim() === '') {
    dashboardValidationFail(path, 'must be a non-empty string');
  }
  return value;
}

export function dashboardStringArray(value: unknown, path: string): string[] {
  if (!Array.isArray(value) || value.length === 0) {
    dashboardValidationFail(path, 'must contain at least one item');
  }
  return value.map((item, index) => dashboardString(item, `${path}[${index}]`));
}

export function dashboardRegisterId(
  value: unknown,
  path: string,
  ids: Set<string>,
): string {
  const id = dashboardString(value, path);
  if (ids.has(id)) dashboardValidationFail(path, `duplicates id "${id}"`);
  ids.add(id);
  return id;
}
